import Cookies from 'js-cookie';

const TokenKey = 'access-token';
const RefreshTokenKey = 'refresh-token';
const LoginInfo = 'login-info';
export function getLoginInfo() {
  return Cookies.get(LoginInfo);
}
export function setLoginInfo(login) {
  return Cookies.set(LoginInfo, login);
}
export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey);
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshTokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey);
}
